import Config from '../../assets/config.json';

export default require('./' + Config.LOCALE + '.json');
